export default __webpack_public_path__ + "resources/icons/n121-6fb0.png";